"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalCss = exports.makeRule = exports.useRule = exports.useTheme = exports.Provider = void 0;
const React = require("react");
const light_1 = require("./themes/light");
const dark_1 = require("./themes/dark");
const css_1 = require("./css");
const context = React.createContext(light_1.lightTheme);
exports.Provider = React.memo(({ theme, children }) => {
    const value = theme === 'light' ? light_1.lightTheme : dark_1.darkTheme;
    return React.createElement(context.Provider, { value }, children);
});
const useTheme = () => React.useContext(context);
exports.useTheme = useTheme;
const useRule = (fn) => {
    const theme = (0, exports.useTheme)();
    const css = fn(theme);
    const className = css_1.nano.cache(css);
    return className;
};
exports.useRule = useRule;
const makeRule = (fn) => () => (0, exports.useRule)(fn);
exports.makeRule = makeRule;
const useIsomorphicLayoutEffect_1 = require("react-use/lib/useIsomorphicLayoutEffect");
const GlobalCss = () => {
    const theme = (0, exports.useTheme)();
    (0, useIsomorphicLayoutEffect_1.default)(() => {
        document.body.style.background = theme.bg;
        document.body.style.color = theme.g(0.05, 0.85);
    }, [theme]);
    return null;
};
exports.GlobalCss = GlobalCss;
//# sourceMappingURL=react.js.map